import ImageUpload from "../components/ImageUpload";
import React, {useState} from "react";
import axios from "axios";
import {List, ListItem, Box, Button, Typography} from '@mui/material/';
import TextInput from "../components/TextInput";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import * as constants from './../constants'
import MenuAppBar from "../components/MenuAppBar";

const UploadImage = () => {
    const [error, setError] = useState('')
    const submitData = (data) => {
        let input = new FormData()
        input.append('file', data.picture[0])
        axios.post(constants.serverURL + "uploadPicture", data.picture[0],
            {
                withCredentials: true
            }).then(response => {
            window.location.href = constants.websiteURL + '#/main'
        }).catch((error) => {
            if (error.request.responseText === 'expired token') {
                window.location.href = constants.websiteURL + '#/refreshToken?redirect=uploadImage'
            } else {
                setError(error.request.responseText)
            }
        })

    }
    const validationSchema = Yup.object().shape({
        picture: Yup.mixed().test('image-required', '(This question is required)',
            function(value) {
                if(value.length > 0) { return true}
                return false
            }),
    })
    const { control, handleSubmit, formState: { errors }, setValue} = useForm({ resolver: yupResolver(validationSchema), shouldFocusError: true});

    return (
        <div>
            <MenuAppBar title="Picture Upload" signedIn={true}></MenuAppBar>
            <form className='screen'>
                <Box className="box">
                    <List>
                        {
                            error &&
                            <ListItem sx={{ p:2, my:1.5}} className='error-block'>
                                <Typography className="font-16 error-message">{error}</Typography>
                            </ListItem>
                        }
                        <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                            <ImageUpload
                                name={"picture"}
                                control={control}
                                setValue={setValue}
                                question={"Please upload a photo of yourself - we will be creating an avatar of you for your profile card."}
                                errors={errors.picture}
                                required={true}
                            />
                        </ListItem>
                        <Button type='submit' className="m-form-button" variant="outlined" onClick={handleSubmit(submitData)}>Submit</Button>
                    </List>
                </Box>
            </form>
        </div>
    );
};

export default UploadImage;